<template>
  <section ref="searchWidget">
    <div class="search-panel">
      <div class="container-sm search-panel-inner">
        <div class="flex flex-col">
          <div class="mx-auto">
            <div class="product-switcher flex items-center">
              <div
                class="flex cursor-pointer"
                :class="{ 'is-selected': searchType === 'resort' }"
                @click="searchType = 'resort'"
              >
                <svg
                  width="24"
                  height="24"
                  class="cursor-pointer block mr-3 item-icon"
                >
                  <use xlink:href="/img/sprite.svg#ic_resort" />
                </svg>
                <span class="item-label"> Resorts </span>
              </div>
              <div
                class="flex cursor-pointer"
                :class="{ 'is-selected': searchType === 'liveaboard' }"
                @click="searchType = 'liveaboard'"
              >
                <svg
                  width="24"
                  height="24"
                  class="cursor-pointer block mr-3 item-icon"
                >
                  <use xlink:href="/img/sprite.svg#ic_boat" />
                </svg>
                <span class="item-label"> Liveaboards </span>
              </div>
              <div
                class="flex cursor-pointer"
                :class="{ 'is-selected': searchType === 'yacht' }"
                @click="searchType = 'yacht'"
              >
                <svg
                  width="24"
                  height="24"
                  class="cursor-pointer block mr-3 item-icon"
                >
                  <use xlink:href="/img/sprite.svg#ic_charter-yacht"></use>
                </svg>
                <span class="item-label"> Charter Yachts </span>
              </div>
            </div>
          </div>

          <div
            class="input-wrapper relative"
            :class="{ 'is-ecoventure': searchType === 'ecoventure' }"
          >
            <div>
              <free-text-search
                ref="fts"
                click-outside-without=".product-switcher"
                v-model="entry.title"
                @focus="handleSearchFocus"
                @confirmed="handleConfirmed"
                :search-type="searchType"
              />
            </div>

            <div v-if="isShowingDates">
              <date-picker v-model="dates" :search-type="searchType" />
            </div>

            <div v-if="isShowingGuests">
              <guest-picker v-model="guests" :search-type="searchType" />
            </div>

            <div>
              <button
                class="btn btn-primary w-full flex justify-center items-center"
                @click="handleCTA"
                :disabled="isWorking"
              >
                <svg width="24" height="24" class="mr-2 fill-white">
                  <use xlink:href="/img/sprite.svg#ic_search-solid" />
                </svg>
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DatePicker from "../Search/2021/DatePicker";
import FreeTextSearch from "../Search/2021/FreeTextSearch";
import GuestPicker from "../Search/2021/GuestPicker";
import WidgetMixin from "./2021/WidgetMixin";

export default {
  mixins: [WidgetMixin],
  components: {
    FreeTextSearch,
    DatePicker,
    GuestPicker,
  },
  data() {
    return {
      searchType: "resort",
      entry: {
        title: "",
      },
      dates: [],
      guests: "0",
      isWorking: false,
    };
  },
  computed: {
    isShowingDates() {
      return this.searchType !== "ecoventure";
    },
    isShowingGuests() {
      return this.searchType !== "ecoventure";
    },
  },
  methods: {
    handleSearchFocus() {
      const top =
        $(this.$refs.searchWidget).position().top - $("header").height() - 24;
      const page = $("html, body");

      page.on(
        "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove",
        () => {
          page.stop();
        }
      );

      page.animate({ scrollTop: top }, "slow", () => {
        page.off(
          "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove"
        );
      });
    },
  },
};
</script>

<style scoped>
.search-panel {
  left: 0;
  right: 0;
  top: 100%;
  box-shadow: none;
}

.search-panel-inner {
  background-color: #f6f6f6;
  border-top: none;
  padding: 50px 27px;
  border-radius: 0.5rem;
}

.product-switcher {
  gap: 4rem;
}

.is-selected {
  fill: var(--secondary);
  color: var(--secondary);
  font-weight: 500;
}

.is-selected span {
  position: relative;
}

.is-selected span::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 2px;
  right: 2px;
  height: 2px;
  background: var(--secondary);
  border-radius: 100vh;
}

.input-wrapper {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 250px;
  gap: 1.5rem;
  margin-top: 35px;
}

.input-wrapper.is-ecoventure {
  grid-template-columns: auto 250px;
}

.search-panel ::v-deep .search-input {
  border: 1px solid #e5e5e5;
}

.search-panel ::v-deep .drop-panel {
  top: calc(100% + 16px);
}

.search-panel-inner {
  background-color: #a7a7a738 !important;
}

.is-selected {
  fill: var(--primary) !important;
  color: var(--primary) !important;
  font-weight: 600 !important;
}

.is-selected span::after {
  background: white !important;
}

.item-label {
  color: white;
  font-size: 18px;
}

.item-icon {
  fill: var(--primary);
}
</style>
